import type { FunctionComponent } from 'react'
import React from 'react'

import { Icon } from '../../Icon'
import type { Icon as IconProps } from '../../Icon/Icon'
import styles from '../Icons.module.scss'

export const HighEnergyIcon: FunctionComponent<IconProps> = ({
  fill,
  width = 68,
  height = 34,
  ...rest
}) => {
  return (
    <Icon
      data-testid="needs-based-filter-icon-highEnergy"
      fill={fill}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      width={width}
      {...rest}
    >
      <g fill="none" fillRule="evenodd">
        <polygon fill="#ffffff" className={styles.white} opacity="0" points="0 34 68 34 68 0 0 0" />
        <path
          d="M29.2432,5 L24.6592,18.947 C24.6762,18.969 24.6822,18.978 24.6992,19 L31.0662,19 C31.0832,19.022 31.0902,19.031 31.1062,19.052 L27.5262,32.774 C27.5152,32.819 27.5742,32.847 27.6012,32.809 L43.4222,10.065 C43.4072,10.036 43.4042,10.03 43.3882,10 L34.4242,10 C34.4242,10 34.3762,10.201 34.3842,10.174 L35.5032,5 L29.2432,5 Z"
          fill="#0050B3"
          className={styles.interactiveColor}
        />
        <path
          d="M36.946,0 L30.114,0 C29.6531659,0 29.2460254,0.303504731 29.1156345,0.746833676 L23.7411781,18.6606374 L23.712216,18.7783754 C23.5961088,19.4050607 24.0845644,20 24.738,20 L29.697,20 L26.4293745,32.5276097 C26.1253302,33.6422044 27.6172844,34.3422752 28.2871917,33.3889455 L44.1159067,10.6350624 L44.1755432,10.5403031 C44.5516814,9.86696596 44.0686565,9 43.262,9 L35.644,9 L37.9428204,1.33936764 C38.1483037,0.671630707 37.6402753,0 36.946,0 Z M35.656,2 L33.3581796,9.66063236 L33.3292173,9.77837121 C33.2131088,10.4050607 33.7015644,11 34.355,11 L41.425,11 L29.723,27.822 L31.9456255,19.3033903 L31.9697703,19.1883325 C32.0623725,18.5762293 31.5846397,18 30.939,18 L26.027,18 L30.827,2 L35.656,2 Z"
          fill="#00000"
          className={styles.defaultColor}
          fillRule="nonzero"
        />
      </g>
    </Icon>
  )
}
